import { HLS_KR, SS, IP_MULTICAST, DASH_CMAF } from '../../utils/playerConstants';
import storage from '../../components/DeviceStorage/DeviceStorage';

let deviceInfo =
  window.AndroidPlayerInterface && window.AndroidPlayerInterface.getDeviceInformation
    ? window.AndroidPlayerInterface.getDeviceInformation()
    : '{}';
deviceInfo = JSON.parse(deviceInfo);

const multipleaudio = {};
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// MULTICAST
multipleaudio.ip_multicast = {};
multipleaudio.ip_multicast.vod = false;
multipleaudio.ip_multicast.live = false;
multipleaudio.ip_multicast.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [SS];
supported_stream_types.live = [DASH_CMAF, IP_MULTICAST, HLS_KR];
supported_stream_types.timeshift = [HLS_KR];


export default {
  appKey: storage.getItem('force_appkey')
    ? 'be887bcdafe805358a580961ec7039cb'
    : 'b7566d04ee257cd5bf36939acb09205a', // TODO ESTO ES DE NAGRA
  appSubkey: 'sc7210',
  // Request params
  device_category: 'stb',
  device_id: deviceInfo.device_id, // como obtener device id
  device_manufacturer: 'kaonmedia',
  device_model: 'sc7210',
  device_name: deviceInfo.device_name, // como arman device Name
  device_so: deviceInfo.device_so, // como obtener device_so
  device_type: storage.getItem('force_appkey') ? 'ptv' : 'ott',
  stream_type: 'smooth_streaming',
  appversion: deviceInfo.appversion, // como obtener appversion
  firmwareversion: deviceInfo.firmwareversion, // como obtener firmware version,
  useEpgPostals: true,
  akamai_id: 'STBKaon',
  nodetv: 'nagratv',
  hideArrowHeader: true,
  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  serial_id: deviceInfo.device_id || 'FF05E537L06',
  // akamai_mfwk: 'mfwkstbkaon-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwkstbkaon-api.clarovideo.net' : 'http://mfwkstbkaon-api.clarovideo.net'
  // init: init,
};



// WEBPACK FOOTER //
// ./src/devices/stbkaon/config.js